
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, DialogActions, Card, Typography, FormControlLabel, Checkbox, Alert, AlertTitle } from "@mui/material";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import LoadingBackdrop from "../../../../load/loadingBackdrop";
import { useNavigate, useParams } from "react-router-dom";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import api from "../../../../services/api";
import RegisterAccess from "../../../../utils/registerAccess";


export default function EmissaoAutorizacaoExercicio({ estabelecimento }) {
    const { id } = useParams()
    const { encaminhar } = useParams()
    const navigate = useNavigate()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    const [approveData, setApproveData] = useState('')
    const dispatch = useDispatch()
    // console.log(approveData)

    function handleChange(e) {
        e.target.files ?
            setApproveData((prev) => ({ ...prev, [e.target.name]: e.target.files[0] }))
            :
            setApproveData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const approveEstabelecimento = async () => {
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        await api.patch('/estabelecimento/approve', { ...approveData, estabelecimentoId: id, userId: user._id })
            .then(res => {
                // console.log(res)
                setOpen(false)
                setMessageSuccess(res.data.msg)

                obs && HandleCreateobservacao();
                senEmail()

                dispatch({
                    type: 'alert',
                    payload: { alert: 'O ESTABELECIMENTO FOI APROVADO E EMITIDA A SUA AUTORIZAÇÃO DE EXERCÍCIO.' },
                });

                window.setTimeout(() => {
                    navigate(`/admin/autorizacao-de-exercicio/${id}`)
                    // navigate(`/admin/gestor-licenciados/${id}`)
                }, 3000);

            }).catch(err => {
                setOpen(false)
                setMessageError(err.response.data.message)
            })
    }

    async function HandleCreateobservacao() {
        setOpen(true)
        setMessageError('')
        setMessageSuccess('')

        await api.post('/observacao/create', {
            assunto: encaminhar === 'Aprovação',
            descricao: obs,
            userId: user._id,
            estabelecimentoId: id
        }).then(res => {
            // console.log(res)
            // setobservacao({ ...observacao, descricao: '', assunto: '' })
            setOpen(false)
            setMessageSuccess(res.data.msg)

        }).catch(error => {
            setMessageError(error.response.data.message)
            setOpen(false)
        })
    }

    async function senEmail(email) {

        const msg = {
            to: email,
            subject: 'Estado da solicitação de licenciamento de estabelecimento faramacêutico',
            html: `<h1>A sua Autorização de Exercício foi emitida com sucesso</h1>
           
            <p>
            Este é um email de acompanhamento da solicitação 
            de lienciamento do estabelecimento <b> ${estabelecimento?.nome} </b>
            com o número de entrada <b> ${estabelecimento?.numeroEntrada} </b>
            que submeteu na <b>ARMED</b> 
            </p>
            
            <p>
            Informamos que a Autorização de Exercício para estabelecimento <b> ${estabelecimento?.nome} </b> já foi emitida.
            </p>

            <p><b>Nota:</b> Este e-mail foi gerado automaticamente pela plataforma <b>ARMED</b></p>
     `,
        };

        api.post('/email/send', msg)
            .then(response => {
                // console.log(response)
            }).catch(err => {
                // console.log(err) 
            })
    };

    return (
        <Card style={{ padding: 20, paddingBottom: 30 }}>
            <RegisterAccess page={'emissão de autorização'} />
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}
            <LoadingBackdrop open={open} text={'AGUARDE O ESTABELECIMENTO ESTA A SER APROVADO E AUTORIZADO.'} />


            <Alert severity="info">
                <AlertTitle>Selecionar Opção:</AlertTitle>
                Deve Selecionar o tipo de actividade que se adequou com o estabelecimento.
            </Alert>
            {estabelecimento?.tipo.designacao === 'Farmácia' ?
                <>
                    {/*  OPCAO 1 */}
                    <Typography m marginBottom={2}>
                        <FormControlLabel label={'1 -'} value={'a'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'a' ? true : false} />} onChange={handleChange} />
                        Autoriza a empresa
                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                            {estabelecimento?.empresa.nome}
                        </span>
                        a exercer a
                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                            actividade de venda a {estabelecimento?.tipo?.venda} de medicamentos essenciais de uso humano e material gastável,
                        </span>
                    </Typography>

                    {/*  OPCAO 2 */}
                    <Typography m={2}>
                        <FormControlLabel label={'2 -'} value={'b'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'b' ? true : false} />} onChange={handleChange} />
                        Autoriza a empresa
                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                            {estabelecimento?.empresa.nome}
                        </span>
                        a exercer a
                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                            actividade de venda a {estabelecimento?.tipo?.venda} de medicamentos essenciais de uso humano incluido medicamentos de especialidade e medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial,
                        </span>
                    </Typography>

                    {/*  OPCAO 9 */}
                    <Typography m={2}>
                        <FormControlLabel label={'3 -'} value={'i'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'i' ? true : false} />} onChange={handleChange} />
                        Autoriza a empresa
                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                            {estabelecimento?.empresa.nome}
                        </span>
                        a exercer a
                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                            actividade de venda a retalho de equipamento médico, meios de diagnóstico e material hospitalar,
                        </span>
                    </Typography>
                </>
                : estabelecimento?.tipo.designacao === 'Importador e Distribuidor' ?
                    <>
                        {/*  OPCAO 3 */}
                        <Typography m={2}>
                            <FormControlLabel label={'1 -'} value={'c'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'c' ? true : false} />} onChange={handleChange} />
                            Autoriza a empresa
                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                {estabelecimento?.empresa.nome}
                            </span>
                            a exercer a
                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                actividade de Importação e Distribuição de material hospitalar e meios de diagnóstico,
                            </span>
                        </Typography>

                        {/*  OPCAO 4 */}
                        <Typography m={2}>
                            <FormControlLabel label={'2 -'} value={'d'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'd' ? true : false} />} onChange={handleChange} />
                            Autoriza a empresa
                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                {estabelecimento?.empresa.nome}
                            </span>
                            a exercer a
                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                actividade de Importação e Distribuição de medicamentos essenciais de uso humano, incluido medicamentos de especialidade e medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial, material gastável e cosméticos,
                            </span>
                        </Typography>
                    </>
                    : estabelecimento?.tipo.designacao === 'Importador' ?
                        <>
                            {/*  OPCAO 5 */}
                            <Typography m={2}>
                                <FormControlLabel label={'1 -'} value={'e'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'e' ? true : false} />} onChange={handleChange} />
                                Autoriza a empresa
                                <span style={{ fontWeight: 'bold', margin: 5 }}>
                                    {estabelecimento?.empresa.nome}
                                </span>
                                a exercer a
                                <span style={{ fontWeight: 'bold', margin: 5 }}>
                                    actividade de Importação de equipamento médico, meios de diagnóstico e material hospitalar,
                                </span>
                            </Typography>

                            {/*  OPCAO 6 */}
                            <Typography m={2}>
                                <FormControlLabel label={'2 -'} value={'f'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'f' ? true : false} />} onChange={handleChange} />
                                Autoriza a empresa
                                <span style={{ fontWeight: 'bold', margin: 5 }}>
                                    {estabelecimento?.empresa.nome}
                                </span>
                                a exercer a
                                <span style={{ fontWeight: 'bold', margin: 5 }}>
                                    actividade de Importação de medicamentos essenciais de uso humano, incluido medicamentos de especialidade de medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial, material gastável e cosméticos,
                                </span>
                            </Typography>
                        </>
                        : estabelecimento?.tipo.designacao === 'Distribuidor' ?
                            <>
                                {/*  OPCAO 7 */}
                                <Typography m={2}>
                                    <FormControlLabel label={'1 -'} value={'g'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'g' ? true : false} />} onChange={handleChange} />
                                    Autoriza a empresa
                                    <span style={{ fontWeight: 'bold', margin: 5 }}>
                                        {estabelecimento?.empresa.nome}
                                    </span>
                                    a exercer a
                                    <span style={{ fontWeight: 'bold', margin: 5 }}>
                                        actividade de Distribuição de equipamento médico, meios de diagnóstico e material hospitalar,
                                    </span>
                                </Typography>

                                {/*  OPCAO 8 */}
                                <Typography m={2}>
                                    <FormControlLabel label={'2 -'} value={'h'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'h' ? true : false} />} onChange={handleChange} />
                                    Autoriza a empresa
                                    <span style={{ fontWeight: 'bold', margin: 5 }}>
                                        {estabelecimento?.empresa.nome}
                                    </span>
                                    a exercer a
                                    <span style={{ fontWeight: 'bold', margin: 5 }}>
                                        actividade de Distribuição de medicamentos essenciais de uso humano, incluido medicamentos de especialidade de medicamentos contendo substâncias psicotrópicas e estupefacientes sujeitos à legislação especial, material gastável e cosméticos,
                                    </span>
                                </Typography>

                                {/*  OPCAO 9 */}
                                <Typography m={2}>
                                    <FormControlLabel label={'3 -'} value={'o'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'o' ? true : false} />} onChange={handleChange} />
                                    Autoriza a empresa
                                    <span style={{ fontWeight: 'bold', margin: 5 }}>
                                        {estabelecimento?.empresa.nome}
                                    </span>
                                    a exercer a
                                    <span style={{ fontWeight: 'bold', margin: 5 }}>
                                        actividade de armazenar e distribuir gases medicinais as instituições sanitárias,
                                    </span>
                                </Typography>
                            </>
                            : estabelecimento?.tipo.designacao === 'Óptica' ?
                                <>
                                    {/*  OPCAO 10 */}
                                    <Typography m={2}>
                                        <FormControlLabel label={'1 -'} value={'j'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'j' ? true : false} />} onChange={handleChange} />
                                        Autoriza a empresa
                                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                                            {estabelecimento?.empresa.nome}
                                        </span>
                                        a exercer a
                                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                                            actividade de importação e distribuição de equipamento para oftalmologia e optometria, lentes, lentes oculares e material de diagnóstico optico,
                                        </span>
                                    </Typography>

                                    {/*  OPCAO 11 */}
                                    <Typography m={2}>
                                        <FormControlLabel label={'2 -'} value={'k'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'k' ? true : false} />} onChange={handleChange} />
                                        Autoriza a empresa
                                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                                            {estabelecimento?.empresa.nome}
                                        </span>
                                        a exercer a
                                        <span style={{ fontWeight: 'bold', margin: 5 }}>
                                            actividade de venda a retalho de equipamento para oftalmologia e optometria, lentes, lentes oculares e material de diagnóstico optico,
                                        </span>
                                    </Typography>
                                </>
                                : estabelecimento?.tipo.designacao === 'Loja de Cosméticos' ?
                                    <>
                                        {/*  OPCAO 12 */}
                                        <Typography m={2}>
                                            <FormControlLabel label={'1 -'} value={'l'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'l' ? true : false} />} onChange={handleChange} />
                                            Autoriza a empresa
                                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                                {estabelecimento?.empresa.nome}
                                            </span>
                                            a exercer a
                                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                                actividade de venda a retalho de cosmeticos,
                                            </span>
                                        </Typography>

                                        {/*  OPCAO 13 */}
                                        <Typography m={2}>
                                            <FormControlLabel label={'2 -'} value={'m'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'm' ? true : false} />} onChange={handleChange} />
                                            Autoriza a empresa
                                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                                {estabelecimento?.empresa.nome}
                                            </span>
                                            a exercer a
                                            <span style={{ fontWeight: 'bold', margin: 5 }}>
                                                actividade de importação e distribuição de produtos cosmeticos,
                                            </span>
                                        </Typography>
                                    </>
                                    : estabelecimento?.tipo.designacao === 'Ervanária' ?
                                        <>
                                            {/*  OPCAO 14 */}
                                            <Typography m={2}>
                                                <FormControlLabel label={'1 -'} value={'n'} name='tipoAutorizacao' control={<Checkbox checked={approveData?.tipoAutorizacao === 'n' ? true : false} />} onChange={handleChange} />
                                                Autoriza a empresa
                                                <span style={{ fontWeight: 'bold', margin: 5 }}>
                                                    {estabelecimento?.empresa.nome}
                                                </span>
                                                a exercer a
                                                <span style={{ fontWeight: 'bold', margin: 5 }}>
                                                    actividade de venda a retalho de produtos naturais e suplementos de uso humano,
                                                </span>
                                            </Typography>
                                        </>
                                        : ''
            }


            <br />
            <Alert severity="info">
                <AlertTitle>Restrições:</AlertTitle>
            </Alert>
            <Typography m>
                <FormControlLabel label={'1 -'} value={'a'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'a' ? true : false} />} onChange={handleChange} />
                Nenhuma
            </Typography>

            <Typography m={2}>
                <FormControlLabel label={'2 -'} value={'b'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'b' ? true : false} />} onChange={handleChange} />
                Psicotrópicos, Estupefacientes e outros medicamentos sujeitos à legislação especial.
            </Typography>

            <Typography m={2}>
                <FormControlLabel label={'3 -'} value={'c'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'c' ? true : false} />} onChange={handleChange} />
                Medicamento, material gastável e outros produtos de saude não descrito no paragrafo terçeiro.
            </Typography>

            <Typography m={2}>
                <FormControlLabel label={'4 -'} value={'d'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'd' ? true : false} />} onChange={handleChange} />
                Medicamento, material gastável, equipamentos medicos, material hospitalar e outros produtos de saude não descrito no paragrafo terçeiro.
            </Typography>

            <Typography m={2}>
                <FormControlLabel label={'5 -'} value={'e'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'e' ? true : false} />} onChange={handleChange} />
                Equipamento médico, meios de diagnóstico e outros produtos de saúde não descritos no parágrafo terceiro.
            </Typography>

            <Typography m={2}>
                <FormControlLabel label={'6 -'} value={'f'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'f' ? true : false} />} onChange={handleChange} />
                Medicamento, material gastável e outros produtos de saúde não descritos no parágrafo terceiro.
            </Typography>
            <Typography m={2}>
                <FormControlLabel label={'7 -'} value={'g'} name='restricaoAutorizacao' control={<Checkbox checked={approveData?.restricaoAutorizacao === 'g' ? true : false} />} onChange={handleChange} />
                Medicamento convencionais, equipamentos médicos, meios de diagnóstico e outros produtos de saúde não descritos no parágrafo terceiro.
            </Typography>
            <br />

            <FazerObservacoes setObs={setObs} obs={obs} titulo={'(caso seja necessário fazer alguma observação)'} />
            <DialogActions>
                <Button color="error" onClick={() => navigate(`/admin/analise/solicitacao-de-licenciamento/${id}`)} >Cancelar</Button>
                <Button disabled={!approveData?.tipoAutorizacao} color="success" variant="contained" onClick={approveEstabelecimento}>Confirmar</Button>
            </DialogActions>
        </Card>
    )
}